import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";

const LegalPage = ({ title, children }) => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      {/* Header */}
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            background: "linear-gradient(45deg, #8b0000, #ff4d4d)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
            mb: 1,
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="subtitle2"
          sx={{ color: "text.secondary" }}
        >
          Zolang Nexora Softwares
        </Typography>
      </Box>

      <Divider sx={{ mb: 4 }} />

      {/* Content */}
      <Box
        sx={{
          fontSize: "1rem",
          lineHeight: 1.9,
          color: "text.primary",
        }}
      >
        {children}
      </Box>
    </Container>
  );
};

export default LegalPage;
